export const errorMessage = 'CPF ou CNPJ inválido. Verifique e tente novamente.';
